/* eslint-disable jsx-a11y/control-has-associated-label */ function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
import { cva } from "class-variance-authority";
import { cn } from "../../common/helpers.js";
import { Icon } from "../Icon/index.js";
const classes = cva([
    'relative',
    'flex',
    'flex-row',
    'justify-center',
    'gap-2',
    'rounded',
    'px-5',
    'py-3',
    '[&_p]:font-semibold',
    '[&_a]:font-bold',
    '[&_a]:hover:text-inherit',
    '[&_*]:text-sm'
], {
    variants: {
        variant: {
            filled: [],
            outlined: [
                'border',
                'text-gray-700'
            ]
        },
        severity: {
            default: [],
            success: [],
            info: [],
            warning: [],
            error: []
        },
        close: {
            true: [
                'pr-12'
            ],
            false: [
                'pr-5'
            ]
        }
    },
    compoundVariants: [
        {
            severity: 'default',
            variant: 'filled',
            className: [
                'bg-secondary-200',
                '[&_*]:text-gray-700'
            ]
        },
        {
            severity: 'info',
            variant: 'filled',
            className: [
                'bg-primary-50',
                '[&_*]:text-gray-700'
            ]
        },
        {
            severity: 'success',
            variant: 'filled',
            className: [
                'bg-success',
                '[&_*]:text-white'
            ]
        },
        {
            severity: 'warning',
            variant: 'filled',
            className: [
                'bg-warning',
                '[&_*]:text-white'
            ]
        },
        {
            severity: 'error',
            variant: 'filled',
            className: [
                'bg-danger',
                '[&_*]:text-white'
            ]
        },
        {
            severity: 'default',
            variant: 'outlined',
            className: [
                'border-secondary-200',
                'bg-white'
            ]
        },
        {
            severity: 'info',
            variant: 'outlined',
            className: [
                'border-primary',
                'bg-white'
            ]
        },
        {
            severity: 'success',
            variant: 'outlined',
            className: [
                'border-success',
                'bg-white'
            ]
        },
        {
            severity: 'warning',
            variant: 'outlined',
            className: [
                'border-warning',
                'bg-white'
            ]
        },
        {
            severity: 'error',
            variant: 'outlined',
            className: [
                'border-danger',
                'bg-white'
            ]
        }
    ]
});
const iconClasses = cva([
    'mt-1'
], {
    variants: {
        variant: {
            filled: [],
            outlined: []
        },
        severity: {
            default: [],
            success: [],
            info: [],
            warning: [],
            error: []
        }
    },
    compoundVariants: [
        {
            variant: 'filled',
            severity: [
                'default',
                'info'
            ],
            className: [
                'text-gray-700'
            ]
        },
        {
            variant: 'filled',
            severity: [
                'success',
                'warning',
                'error'
            ],
            className: [
                'text-white'
            ]
        },
        {
            variant: 'outlined',
            severity: 'default',
            className: [
                'text-secondary-200'
            ]
        },
        {
            variant: 'outlined',
            severity: 'info',
            className: [
                'text-primary'
            ]
        },
        {
            variant: 'outlined',
            severity: 'success',
            className: [
                'text-success'
            ]
        },
        {
            variant: 'outlined',
            severity: 'warning',
            className: [
                'text-warning'
            ]
        },
        {
            variant: 'outlined',
            severity: 'error',
            className: [
                'text-danger'
            ]
        }
    ]
});
const severityToIcon = {
    'default': 'circle-info',
    'info': 'circle-info',
    'success': 'circle-check',
    'warning': 'triangle-exclamation',
    'error': 'triangle-exclamation'
};
/**
 * Alert - [API](https://scl.sharp.com/?path=/docs/components-alert) | [DSM](https://sharphealthcare.notion.site/Alert-0c6a27d517c845fba9fa06ff25c5e8c4)
 */ const Alert = /*#__PURE__*/ forwardRef((_param, ref)=>{
    var { severity = 'default', variant = 'filled', icon = false, onClose, children, className } = _param, props = _object_without_properties(_param, [
        "severity",
        "variant",
        "icon",
        "onClose",
        "children",
        "className"
    ]);
    return /*#__PURE__*/ _jsxs("div", _object_spread_props(_object_spread({}, props), {
        ref: ref,
        className: cn(classes({
            severity,
            variant,
            close: Boolean(onClose),
            className
        })),
        children: [
            icon && /*#__PURE__*/ _jsx(Icon, {
                icon: icon === true ? severityToIcon[severity] : icon,
                className: iconClasses({
                    severity,
                    variant
                })
            }),
            children,
            onClose && /*#__PURE__*/ _jsx("button", {
                type: "button",
                onClick: onClose,
                className: "absolute px-5 py-3 top-0 right-0",
                children: /*#__PURE__*/ _jsx(Icon, {
                    icon: "xmark",
                    title: "Close"
                })
            })
        ]
    }));
});
export { Alert };
